import styled from 'styled-components';

export const TabsButton = styled.button`
  background-color: ${({ theme }) => theme.colors.garnet};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImgTabsButton = styled.img`
  width: 0.7rem;
  height: 1.2rem;
`;
